import { createStyles } from '../../../../../../styles/helpers'

const useStyles = createStyles({
  mediaOrderForm: {
    minHeight: ['100%', '!important'] // remove big empty space at the bottom of the form
  }
})

export default useStyles
